import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/useraction/organization_user_update/`;
export const Csrf = () => `/api/v3/useraction/token/`;
export declare const QueryKey: never;
export type Payload = {
    emails: string[];
    role: `${Models.Organizations.OrganizationMemberRole}`;
};
export type Response = Models.UserAction.OrganizationUser[];
